{
    "nuxtSiteConfig": {
        "description": "",
        "name": ""
    },
    "Bbk": {
        "global": {
            "here": "tutaj",
            "back": "powrót",
            "send": "Wyślij",
            "saveChanges": "Zapisz zmiany",
            "disabledCookies": "Przeglądarka działająca w trybie wyłączonych plików cookies nie pozwala na poprawne działanie naszego serwisu. Włącz pliki cookies lub skorzystaj z innej przeglądarki"
        },
        "badge": {
            "remove": "Remove badge"
        },
        "breadcrumbs": {
            "homeText": "Strona główna"
        },
        "catalog": {
            "allProducts": "produkty",
            "page": "strona",
            "noProducts": "Brak produktów",
            "goToHomepage": "Przejdź na stronę główną",
            "show": "pokaż",
            "products": "produktów",
            "orders": "zamówień"
        },
        "customer": {
            "return": "powrót",
            "login": "logowanie",
            "logout": "wyloguj",
            "sidebar": {
                "account": "konto",
                "orders": "zamówienia",
                "myData": "moje dane",
                "myDataEdit": "edycja danych",
                "addresses": "adresy",
                "salesDocuments": "dokumenty sprzedaży",
                "newsletter": "newsletter",
                "favoriteStore": "ulubiony sklep",
                "favorite": "ulubione",
                "logout": "wyloguj"
            },
            "orders": {
                "title": "zamówienia",
                "status": "status",
                "seller": "sprzedawca",
                "noOrders": "aktualnie nie posiadasz żadnych zamówień",
                "goToHomepage": "przejdź na stronę główną",
                "rating": {
                    "saveRating": "zapisz ocenę",
                    "product": "produkt",
                    "delivery": "dostawa",
                    "package": "opakowanie",
                    "description": "zgodność z opisem",
                    "deliveryTime": "termin dostawy",
                    "rateOrder": "oceń zamówienie",
                    "commentOptional": "komentarz (opcjonalnie)",
                    "approveComment": "zatwierdź komentarz"
                }
            },
            "myData": {
                "updateSuccess": "dane zostały zaktualizowane",
                "changeEmailSuccess": "adres email został zaktualizowany",
                "saveChanges": "zapisz zmiany",
                "changePassword": "zmień hasło",
                "changingPassword": "zmiana hasła",
                "enterPasswordAgain": "aby edytować e-mail wpisz hasło",
                "firstName": "imię",
                "lastName": "nazwisko",
                "and": "i",
                "email": "e-mail",
                "password": "hasło",
                "passwordOld": "stare hasło",
                "passwordNew": "nowe hasło",
                "apply": "zastosuj",
                "changePasswordSuccess": "hasło zostało zmienione",
                "editData": "edytuj dane",
                "dontRememberPassword": "nie pamiętasz hasła?"
            },
            "orderDetails": {
                "seller": "sprzedawca",
                "status": "status",
                "shippingMethod": "dostawa",
                "paymentMethod": "płatność",
                "salesDocument": "dokument sprzedaży",
                "products": "produkty",
                "value": "wartość",
                "productsValue": "wartość produktów",
                "shippingAndHandling": "wysyłka i obsługa",
                "totalExcludingTax": "suma łączna (bez podatku)",
                "tax": "podatek",
                "totalIncludingTax": "suma łączna z podatkiem",
                "deliveryDetails": "szczegóły dostawy",
                "carrier": "przewoźnik",
                "deliveryMethod": "sposób dostawy",
                "collectionPoint": "punkt odbioru",
                "trackingNumber": "nr przesyłki",
                "recipientDetails": "dane odbiorcy",
                "firstLastName": "imię i nazwisko",
                "address": "adres",
                "email": "e-mail",
                "phoneNumber": "nr telefonu",
                "ratePurchase": "oceń zakup",
                "askForPurchase": "zapytaj o zakup",
                "confirmReceipt": "potwierdź odbiór",
                "buyAgain": "kup ponownie",
                "back": "powrót do listy zamówień",
                "openIncident": "otwórz incydent"
            },
            "newsletter": {
                "title": "Newsletter",
                "heading": "subskrypcje",
                "headingNoSubscriptions": "aktualnie nie posiadasz żadnych subskrypcji",
                "subscribed": "Twoja subskrypcja została pomyślnie zaktualizowana",
                "sms": "W celu zamówienia usługi newslettera SMS",
                "cancel": "W celu zrezygnowania z zamówionej usługi",
                "fill": "wypełnij formularz",
                "saveButton": "naciśnij przycisk \"zapisz\"",
                "uncheck": "odznacz właściwy checkbox",
                "saveChangesButton": "naciśnij przycisk \"zapisz zmiany\""
            },
            "address": {
                "heading": "Zarządzaj adresami",
                "add": "Dodaj adres",
                "newAdd": "Dodaj nowy adres",
                "addHeading": "dodawanie adresu",
                "save": "Zapisz adres",
                "edit": "Edycja adresu",
                "editAddress": "edytuj adres",
                "new": "Nowy adres",
                "success": "Adres został zapisany",
                "person": "Osoba prywatna",
                "company": "Firma",
                "removeQuestion": "Usunąć adres?",
                "remove": "Usuń",
                "removeSuccess": "Adres został usunięty",
                "noAddress": "Nie masz jeszcze zapisanych adresów",
                "companyFullName": "pełna nazwa firmy",
                "vatId": "nip",
                "name": "imię i nazwisko",
                "address": "adres",
                "postCode": "kod pocztowy",
                "city": "miejscowość",
                "phoneNumber": "nr telefonu",
                "defaultShipping": "domyślny adres dostawy",
                "defaultBilling": "domyślny adres rachunku"
            },
            "incident": {
                "openIncident": "otwórz incydent"
            }
        },
        "wishlist": {
            "heading": "moja lista życzeń",
            "title": "Lista życzeń",
            "addAll": "Dodaj wszystko",
            "oneItemAddedToCart": "Produkt został dodany do koszyka",
            "allItemsAddedToCart": "Wszystkie produkty zostały dodane do koszyka",
            "toCart": "do koszyka",
            "placeholder": "komentarz",
            "saveComment": "zatwierdź komentarz",
            "editComment": "edytuj",
            "removeComment": "usuń",
            "share": "Udostępnij",
            "shareTitle": "Udostępnianie listy życzeń",
            "shareSubTitle": "podziel się listą",
            "shareEmail": "adresy e-mail rozdzielane przecinkami",
            "shareMessage": "wiadomość",
            "shareSuccess": "Lista życzeń została udostępniona",
            "list": "listę",
            "updateSuccess": "Lista życzeń została zaktualizowana",
            "removeSuccess": "Produkt został usunięty z listy życzeń"
        },
        "expandHtml": {
            "collapse": "zwiń",
            "expand": "rozwiń"
        },
        "404": {
            "notFound": "Szukana strona nie istnieje",
            "goHomePage": "Przejdź do strony głównej"
        },
        "500": {
            "error": "Coś nam tu się nie zgadza. Staramy się rozwiązać problem"
        },
        "filters": {
            "title": "filtry",
            "activeTitle": "wybrane filtry",
            "categoryTitle": "kategorie",
            "allLabel": "wszystkie",
            "noFilters": "Brak filtrów",
            "clearAll": "resetuj wszystko",
            "clear": "WYCZYŚĆ",
            "sorting": "sortuj",
            "apply": "ZASTOSUJ",
            "showMore": "pokaż więcej",
            "showLess": "pokaż mniej",
            "price": "cena",
            "sort": {
                "positionASC": "rekomendowane",
                "PRICEASC": "cena od najniższej",
                "PRICEDESC": "cena od najwyższej",
                "POPULARITYDESC": "popularność",
                "visit_counterDESC": "popularność",
                "newProducts": "nowości",
                "NEW_PRODUCTSDESC": "nowości"
            },
            "label": {
                "color": "kolor",
                "colors": "kolor",
                "brand_label": "marka",
                "categories": {
                    "name": "kategoria"
                },
                "collection_christmas": "kolekcje"
            },
            "quartiles": {
                "below": "poniżej",
                "above": "powyżej",
                "to": "do"
            }
        },
        "gtm": {
            "inStorage": "W magazynie"
        },
        "page": {
            "product": {
                "notExist": "Produkt nie istnieje"
            },
            "error": {
                "message": "Błąd"
            }
        },
        "carousel": {
            "related": "Inni wybrali",
            "collection": "Inne z tej kolekcji",
            "series": "inne z tej serii",
            "suggested": "mogą cię zainteresować"
        },
        "product": {
            "reservation": {
                "title": "dostępność i rezerwacja w salonie",
                "panelTitle": "Wybierz salon i zarezerwuj",
                "panelHeading": "Wpisz miejscowość i wybierz salon",
                "searchPlaceholder": "miejscowość",
                "notAvailable": "Wyprzedano online, dostępny tylko stacjonarnie.",
                "available": "dostępność",
                "city": "miejscowość",
                "less": "pokaż mniej",
                "more": "pokaż więcej",
                "take": "załaduj więcej",
                "error": "Niestety nie mamy sklepów w tym miejscu. Wpisz inne miasto.",
                "lastSelectedShopNoSupply": "Wybrany salon nie ma dostępności dla tego produktu. Proszę wybrać inny salon.",
                "openTimeWeek": "pon.-pt.",
                "openTimeSat": "sob.",
                "openTimeSun": "niedz.",
                "notFound": "Niestety nie mamy sklepów w tym miejscu. Wpisz inne miasto",
                "change": "Zmień salon",
                "switcherLabel": "pokaż tylko dostępne",
                "confirm": "Potwierdzenie",
                "thankYou": "Dziękujemy za rezerwację produktu",
                "successMessage": "Powiadomimy Cię poprzez SMS i e-mail, gdy nasz zespół skompletuje Twoje zamówienie",
                "chooseShop": "Wybierz salon",
                "productReservationDisabled": "rezerwacja tymczasowo niemożliwa",
                "reservationNumber": "Numer twojego zamówienia to:",
                "notification": {
                    "error": "Coś poszło nie tak"
                },
                "availability": {
                    "0": "wysoka",
                    "1": "niska",
                    "2": "średnia",
                    "3": "brak",
                    "4": "możliwy brak"
                },
                "form": {
                    "firstName": "imię",
                    "lastName": "nazwisko",
                    "phone": "telefon",
                    "email": "email",
                    "submit": "rezerwuję i płacę w salonie"
                }
            },
            "card": {
                "addToCart": "do koszyka",
                "addToCartAll": "dodaj wszystko do koszyka",
                "productDescription": "opis produktu",
                "shippingMethods": {
                    "title": "Dostawa i płatność",
                    "courier": {
                        "title": "kurier",
                        "line1": "czas realizacji podany w koszyku",
                        "line2": "zamówienie do 250 zł – 15,00 zł",
                        "line3": "zamówienie od 250 zł – 0,00 zł",
                        "line4": "płatność online / za pobraniem"
                    },
                    "inPost": {
                        "title": "InPost",
                        "line1": "czas realizacji podany w koszyku",
                        "line2": "zamówienie do 250 zł – 9,99 zł",
                        "line3": "zamówienie od 250 zł – 0,00 zł",
                        "line4": "płatność online"
                    },
                    "collect": {
                        "title": "odbiór w salonie",
                        "line1": "czas realizacji podany w koszyku",
                        "line2": "płatność tylko online",
                        "line3": "koszt dostawy 0 zł"
                    },
                    "reservation": {
                        "title": "rezerwacja i odbiór w salonie",
                        "line1": "odbiór w salonie w dniu rezerwacji",
                        "line2": "płatność przy kasie w salonie",
                        "line3": "koszt dostawy 0 zł"
                    }
                },
                "returns": {
                    "title": "Zwroty",
                    "content": "Zwrotu dokonujesz na własny koszt. Nie przyjmujemy przesyłek pobraniowych jak również zwrotów osobistych.",
                    "contentMirakl": "Więcej informacji na temat Polityki Zwrotów tego Sprzedawcy znajdziesz "
                },
                "details": {
                    "title": "Szczegóły produktu",
                    "noInfo": "Brak dodatkowych informacji",
                    "download": "pobierz"
                },
                "unavailable": "Przepraszamy, produkt niedostępny",
                "unavailableOnline": "Wyprzedano online, dostępny tylko stacjonarnie",
                "salesIndex": "numer katalogowy",
                "logisticIndex": "kod produktu"
            },
            "price": {
                "averagePrice": "najniższa cena z ostatnich 30 dni:",
                "averagePriceProduct": "najniższa cena z 30 dni przed obniżką:",
                "regularPrice": "cena regularna:",
                "withTax": "Z podatkiem"
            },
            "sellAndShip": "sprzedawane i wysyłane przez: ",
            "sellAndShipShort": "sprzedawane przez: ",
            "legalText": "Produkt jest sprzedawany przez Sprzedawcę Marketplace w ramach internetowej platformy handlowej Marketplace Home&You. Każdy Sprzedawca Marketplace jest przedsiębiorcą. Umowa sprzedaży zawierana jest ze Sprzedawcą Marketplace. Wszystkie obowiązki związane z umową sprzedaży oraz odpowiedzialność za realizację zamówienia spoczywają na Sprzedawcy Marketplace. Sprzedawca Marketplace jest wyłącznie odpowiedzialny za przestrzeganie praw konsumenta.",
            "amount": "szt.",
            "from": "od",
            "chooseSize": "wybierz rozmiar",
            "otherSizeAvailable": "dostępne inne rozmiary"
        },
        "search": {
            "result": "Wyniki wyszukiwania dla:",
            "noResult": "Brak wyników wyszukiwania"
        },
        "notification": {
            "show": "Pokaż",
            "close": "Zamknij",
            "addedToCart": "Dodano do koszyka",
            "addedToWishList": "dodano do listy życzeń",
            "continueShopping": "Kontynuuj zakupy",
            "goToCard": "Przejdź do koszyka",
            "loginError": "Wpisałeś niepoprawny login/hasło lub konto jest nieaktywne"
        },
        "form": {
            "dataAdministrator": "Administratorem danych osobowych jest home&you S.A. Dane przetwarzamy w celach wskazanych przy polach formularza, do czasu usunięcia konta klienta w sklepie lub rezygnacji z usługi NEWSLETTER. Pełna informacja:",
            "global": {
                "firstName": "imię",
                "lastName": "nazwisko",
                "phone": "telefon"
            },
            "login": {
                "title": "Logowanie",
                "titleRegister": "Rejestracja",
                "apply": "Zastosuj",
                "emailAddress": "adres e-mail",
                "password": "hasło",
                "forgotPassword": "nie pamiętasz hasła?",
                "signIn": "Zaloguj się",
                "notHaveAccount": "nie masz konta?",
                "haveAccount": "masz konto?",
                "whyHaveAccount": "co zyskujesz zakładając konto?",
                "createAccount": "Załóż konto",
                "historyOrders": "historia zamówień",
                "fasterShopping": "szybsze zakupy",
                "addressBook": "książka adresowa",
                "favoritesList": "lista ulubionych"
            },
            "register": {
                "title": "Formularz rejestracyjny",
                "email": "email",
                "password": "hasło",
                "repeatPassword": "powtórz hasło",
                "createAccount": "Załóż konto",
                "infoText": "Uzupełnienie danych jest niezbędne do zabezpieczenia Konta.",
                "confirmation": "Potwierdzenie",
                "linkSent": "Link do rejestracji został wysłany",
                "linkToConfirm": "Na podany adres został wysłany link do potwierdzenia konta"
            },
            "validator": {
                "required": "*to pole jest wymagane",
                "dependableRequired": "*to pole jest wymagane",
                "email": "niewłaściwy format adresu",
                "matches": "proszę wpisać poprawne dane",
                "confirm": "Hasła się nie zgadzają",
                "containsUppercase": "musi zawierać co najmniej jedną wielką literę",
                "containsLowercase": "musi zawierać co najmniej jedną małą literę",
                "containsNumeric": "musi zawierać co najmniej jedną cyfrę",
                "postCode": "wpisz kod w prawidłowym formacie 00-000",
                "telephone": "niewłaściwy format telefonu",
                "nip": "sprawdź poprawność numeru NIP\n(10 cyfr bez dodatkowych znaków)"
            },
            "reset": {
                "send": "Wyślij",
                "heading": "Zapomniałeś hasła?",
                "content": "Podaj swój adres e-mail poniżej, aby otrzymać link do zresetowania hasła.",
                "emailAddress": "e-mail"
            },
            "create": {
                "apply": "Zastosuj",
                "heading": "Nowe hasło",
                "newPassword": "Nowe hasło",
                "confirmPassword": "Powtórz nowe hasło",
                "passwordStrength": "siła hasła",
                "passwordStrong": "silne",
                "passwordMedium": "średnie",
                "passwordWeak": "słabe"
            },
            "confirmation": {
                "heading": "Potwierdzenie",
                "resetContent": "Jeśli istnieje konto użytkownika powiązane z wprowadzonym adresem email wyślemy do Ciebie wiadomość z linkiem do zresetowania hasła",
                "createContent": "Hasło zostało pomyślnie zmienione"
            }
        },
        "cart": {
            "mini": {
                "goToCart": "przejdź do koszyka",
                "toPay": "do zapłaty"
            }
        },
        "newsletter": {
            "title": "Newsletter",
            "form": {
                "title": "Newsletter",
                "description": "We all know the saying:<br/>tidy home equals tidy mind.",
                "join": "Chcesz być na bieżąco? Dołącz do newslettera home&you",
                "benefits": "Poznaj korzyści płynące z subskrypcji newslettera e-mail lub sms:",
                "benefitsList": [
                    "RABAT 10% NA KOLEJNE ZAKUPY* W HOME&YOU",
                    "informacje o najnowszych produktach i kolekcjach",
                    "powiadomienia o zbliżających się akcjach promocyjnych i wyprzedażach",
                    "inspiracje i porady wnętrzarskie"
                ],
                "titleInputs": "FORMULARZ REJESTRACYJNY",
                "disclaimer": "*jednorazowy kod rabatowy obowiązuje tylko na produkty nieprzecenione marki home&you; nie obejmuje on zakupu kart podarunkowych i nie łączy się z innymi promocjami i rabatami; szczegóły w regulaminie usługi newsletter",
                "fillForm": "UZUPEŁNIJ FORMULARZ, ABY CIESZYĆ SIĘ ZE WSZYSTKICH BENEFITÓW",
                "questions": "Masz dodatkowe pytania? Napisz do nas: <br /> <strong>{email}</strong>",
                "selectAll": "zaznacz wszystko",
                "defaultAgreement": "akceptuję warunki regulaminu.",
                "firstName": "imię",
                "email": "e-mail",
                "phone": "telefon",
                "submit": "zapisz",
                "agreementsNotSelected": "zgody nie zostały zaznaczone",
                "successMessage": "Dziękujemy za zapisanie się do newslettera!",
                "removeSuccessMessage": "Status subskrypcji został zmieniony!"
            },
            "remove": {
                "title": "Będziemy tesknić",
                "description": "Twój adres e-mail <strong>został wypisany z naszej bazy</strong>."
            },
            "success": {
                "title": "<strong>Cieszymy się że chcesz być z nami w kontakcie</strong>",
                "paragraphEmail": "Na Twój adres e-mail <strong>{email}</strong> wyślemy wiadomość z linkiem aktywacyjnym",
                "paragraphSms": "Na Twój numer telefonu <strong>{phone}</strong> wyślemy wiadomość z linkiem aktywacyjnym",
                "paragraphMix": "Na Twój adres e-mail <strong>{email}</strong> i numer telefonu <strong>{phone}</strong> wyślemy wiadomość z linkiem aktywacyjnym",
                "paragraphTwo": "Jeśli potwierdzenie nie przyszło w ciagu np. 15 minut należy sprawdzić folder spam",
                "paragraphThree": "<strong>Jeśli wybrałeś oba kanały subskrypcji, pamiętaj, aby potwierdzić zapis do każdego z nich.</strong>",
                "paragraphFour": "Jeśli podałeś adres mailowy i <strong>nie możesz znaleźć wiadomości w swojej skrzynce, sprawdź foldery: „SPAM”, „oferty” lub podobne</strong>, do których wiadomość mogła zostać skierowana.\n\n",
                "paragraphFive":  "Jeśli podałeś numer telefonu i <strong>nie otrzymałeś wiadomości SMS, upewnij się, że minęło 10 minut i wprowadź dane ponownie.</strong>",
                "paragraphSix": "*jednorazowy rabat do wykorzystania na homeA-you.com w ciągu 30 dni od dnia otrzymania wiadomości z kodem; szczegóły w regulaminie usługi newsletter",
                "promotion": "Kliknij w niego, by dokończyć proces zapisu do newslettera i odebrać <strong>rabat 10%* dla nowych subskrybentów</strong> oraz aby być na bieżąco z nowościami i akcjami promocyjnymi!",
                "goToHomepage": "Przejdź do strony głównej"
            },
            "confirm": {
                "title": "Dziękujemy, że jesteś z nami.",
                "paragraphOne": "Na twój adres e-mail wyślemy wiadomość z <strong>kodem rabatowym 10%</strong>",
                "paragraphTwo": "Życzymy udanych zakupów.",
                "goToHomepage": "Przejdź do strony głównej"
            }
        },
        "newsletter-remove": {
            "form": {
                "information": "Informujemy, że przesłana informacja marketingowa, jest wynikiem wyrażenia przez Panią/Pana dobrowolnej zgody na otrzymywanie od nas informacji handlowej na podany numer telefonu lub adres e-mail.",
                "information-processing": "Informacje o zasadach przetwarzania danych osobowych oraz przysługujących z tego tytułu prawach znajdują się pod adresem",
                "information-goal": "W celu wycofania wyrażonych dobrowolnie zgód marketingowych prosimy o skorzystanie z poniższego formularza.",
                "title": "Newsletter - wypis",
                "titleInputs": "Formularz wycofania zgód marketingowych",
                "benefits": "Uzupełnij formularz, aby wycofać następujące zgody:",
                "benefitsList": [
                    "usługa newsletter e-mail",
                    "usługa newsletter sms",
                    "Karta Stałego Klienta"
                ],
                "submit": "Wycofaj moje zgody"
            },
            "cartTitle": "Karta Stałego Klienta:",
            "cartText": "W przypadku posiadania Karty Stałego Klienta, możesz zarządzać swoimi zgodami marketingowymi wyłącznie kontaktując się z Biurem Obsługi Klienta pod adresem:  "
        }
    }
}
